import {TabState, TabStateDefaults} from 'Navigation';

export default class StudyOverviewTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Study overview',
      closeable: false,
      preferenceKey: 'study-overview',
    };
  }
}
